<template>
    <div>
        <b-modal
            id="m-buat-temuan"
            title="Buat Temuan"
            size="lg"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            @show="init"
        >
            <b-row>
                <b-col md="12">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Berat Kotor <span style="color: red;">*</span> <small class="text-muted">(Gunakan titik "." untuk desimal)</small>
                        </template>
                        <b-input-group append="gr">
                            <b-form-input
                                v-model="input.dry_weight"
                                step="0.01"
                                placeholder="Masukkan Berat Kotor"
                            />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="12">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Berat Potongan <span style="color: red;">*</span> <small class="text-muted">(Gunakan titik "." untuk desimal)</small>
                        </template>
                        <b-input-group append="gr">
                            <b-form-input
                                v-model="input.weight_reduction"
                                step="0.01"
                                placeholder="Masukkan Berat Potongan"
                            />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="12">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Kadar XRF <span style="color: red;">*</span>
                        </template>
                        <b-input-group>
                            <b-form-input
                                v-model="input.purity"
                                step="0.01"
                                placeholder="Masukkan Kadar XRF"
                            />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="12">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Kategori <span style="color: red;">*</span>
                        </template>
                            <multiselect
                                v-model="input.category"
                                :allow-empty="true"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                placeholder="Pilih Kategori"
                                :options="optCategory"
                            />
                    </b-form-group>
                </b-col>
                <b-col md="12">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Video Unboxing
                        </template>
                        <div v-if="!videoPreviewUrl">
                            <b-input-group>
                                <b-form-file
                                    id="unbox-video"
                                    v-model="input.unbox_video"
                                    accept="video/mp4, video/quicktime"
                                    placeholder="Pilih file video unboxing..."
                                    browse-text="Browse"
                                    @change="onVideoFileChange"
                                />
                            </b-input-group>
                        </div>
                        <div v-else class="mt-2 text-left">
                            <div class="position-relative d-inline-block">
                                <video
                                    :src="videoPreviewUrl"
                                    class="img-thumbnail"
                                    style="width: 100px; height: 100px; object-fit: cover;"
                                    preload="metadata"
                                ></video>
                                <b-button
                                    size="sm"
                                    variant="danger"
                                    class="position-absolute"
                                    style="top: 0; right: 0; padding: 0 4px; z-index: 999;"
                                    @click="clearVideoUnboxing"
                                >
                                    &times;
                                </b-button>
                                <div
                                    class="overlay-trigger"
                                    style="position:absolute; top:0; left:0; width:100%; height:100%; cursor: pointer; z-index: 0;"
                                    @click="showPreviewModal({ url: videoPreviewUrl, type: 'video' })"
                                >
                                    <div
                                        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white; background-color: rgba(0,0,0,0.5); border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center;"
                                    >
                                        <i class="fa fa-play"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col md="12">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Foto dan Video Temuan (Max 10)<span style="color: red;"
                                >*</span
                            >
                        </template>
                        <b-form-file
                            ref="fileInput"
                            v-model="tempPhotos"
                            placeholder="Tambah foto dan video..."
                            drop-placeholder="Drop file disini..."
                            multiple
                            accept="image/*,video/*"
                            :file-name-formatter="formatNames"
                            @change="onFileChange"
                        />
                        <div
                            class="mt-2 text-muted"
                            v-if="localPhotos.length > 0"
                        >
                            {{ localPhotos.length }} file dipilih
                        </div>
                    </b-form-group>
                    <div v-if="previews.length" class="d-flex flex-wrap mt-2">
                        <div
                            v-for="(preview, index) in previews"
                            :key="index"
                            class="mr-2 mb-2 position-relative"
                        >
                            <img
                                v-if="preview.type === 'image'"
                                :src="preview.url"
                                class="img-thumbnail"
                                style="width: 100px; height: 100px; object-fit: cover;"
                            />
                            <video
                                v-else-if="preview.type === 'video'"
                                :src="preview.url"
                                class="img-thumbnail"
                                style="width: 100px; height: 100px; object-fit: cover;"
                                preload="metadata"
                            ></video>
                            <b-button
                                size="sm"
                                variant="danger"
                                class="position-absolute"
                                style="top: 0; right: 0; padding: 0 4px; z-index: 999;"
                                @click="removePhoto(index)"
                            >
                                &times;
                            </b-button>
                            <div
                                class="overlay-trigger"
                                style="position:absolute; top:0; left:0; width:100%; height:100%; cursor: pointer; z-index: 0;"
                                @click="showPreviewModal(preview)"
                            >
                                <div
                                    v-if="preview.type === 'video'"
                                    style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white; background-color: rgba(0,0,0,0.5); border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center;"
                                >
                                    <i class="fa fa-play"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col md="12">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Catatan <span style="color: red;">*</span>
                        </template>
                        <b-input-group>
                            <b-form-textarea
                                id="notes"
                                v-model="input.notes"
                                placeholder="Masukkan catatan"
                                rows="4"
                                maxlength="1000"
                            />
                        </b-input-group>
                        <small :class="notesCharCount > 1000 ? 'text-danger' : 'text-muted'">
                            {{ notesCharCount }} / 1000
                        </small>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-modal
                id="m-preview-photo"
                title="Preview Media"
                size="lg"
                hide-footer
            >
                <img
                    v-if="selectedPreviewImage && selectedPreviewImage.type === 'image'"
                    :src="selectedPreviewImage.url"
                    class="img-fluid"
                    width="100%"
                />
                <video
                    v-else-if="selectedPreviewImage && selectedPreviewImage.type === 'video'"
                    :src="selectedPreviewImage.url"
                    class="img-fluid"
                    width="100%"
                    controls
                    autoplay
                ></video>
            </b-modal>

            <div class="text-right mt-3">
                <b-button
                    variant="primary"
                    @click="submitFindings"
                    :disabled="isSubmitting"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
            <loading-overlay
                :fotoStartTime="uploadTimeStamp.startPresignedUrl"
                :fotoEndTime="uploadTimeStamp.endPresignedUrl"
                :uploadStartTime="uploadTimeStamp.startUploadToS3"
                :uploadEndTime="uploadTimeStamp.endUploadToS3"
                :penyimpananStartTime="uploadTimeStamp.startSaveFile"
                :penyimpananEndTime="uploadTimeStamp.endSaveFile"
                :show="isShowLoadingOverlay"
            />
        </b-modal>
    </div>
</template>

<script>
import LoadingOverlay from "../barang-masuk/LoadingOverlay.vue";

export default {
    components: {
        LoadingOverlay
    },
    name: "ModalBuatTemuan",
    props: {
        item: {
            type: Object,
            default: () => null
        },
        type: {
            type: String,
            default: () => "PEI"
        }
    },
    data() {
        return {
            input: {
                dry_weight: null,
                purity: null,
                weight_reduction: null,
                notes: null,
                category: null,
                unbox_video: null
            },
            uploadedUnboxVideoPath: null,
            videoPreviewUrl: null,
            tempPhotos: [],
            localPhotos: [],
            previews: [],
            selectedPreviewImage: null,
            isSubmitting: false,
            uploadTimeStamp: {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null
            },
            uploadedFilePaths: [],
            isShowLoadingOverlay: false,

            optCategory: [],
        };
    },
    computed: {
        findingsDirPath() {
            const dir = {
                PEI: "penerimaan-box-pei/findings",
                RBE: "penerimaan-box-rbe/findings"
            };
            return dir[this.type] || "penerimaan-box-pei/findings";
        },
        notesCharCount() {
            if (!this.input.notes) return 0;
            return this.input.notes.length;
        }
    },
    watch: {
        item(newItem) {
            if (!newItem) {
                return;
            }
            this.resetForm();
        },
    },
    methods: {
        init() {
            this.getCategoryVariance();
        },

        async getCategoryVariance() {
            await this.$axios.get(`master/gold-variance-categories?for=SM&source=${this.type}`)
                .then(response => {
                    this.optCategory = response.data.data;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                });
        },

        async getPresignedUrl(fileName, fileType) {
            this.uploadTimeStamp.startPresignedUrl = this.formatTime(
                new Date()
            );
            const payload = {
                file_name: fileName,
                file_type: fileType,
                reference_key: this.item.no_faktur,
                directory_path: this.findingsDirPath
            };
            const response = await this.$axios.post(
                "get-presigned-url",
                payload
            );
            this.uploadTimeStamp.endPresignedUrl = this.formatTime(new Date());
            return response.data.data;
        },

        async uploadToS3(file, presignedUrl) {
            this.uploadTimeStamp.startUploadToS3 = this.formatTime(new Date());
            const response = await fetch(presignedUrl, {
                method: "PUT",
                body: file,
                headers: {
                    "Content-Type": file.type
                }
            });
            if (!response.ok) throw new Error("Upload to S3 failed");
            this.uploadTimeStamp.endUploadToS3 = this.formatTime(new Date());
            return response;
        },

        resetForm() {
            this.input = {
                dry_weight: null,
                purity: null,
                notes: null,
                category: null,
                weight_reduction: null,
                unbox_video: null
            };
            this.localPhotos = [];
            this.tempPhotos = [];
            this.previews = [];
            this.uploadedFilePaths = [];
            this.uploadedUnboxVideoPath = null;
            this.videoPreviewUrl = null;
        },
        clearVideoUnboxing() {
            this.videoPreviewUrl = null;
            this.uploadedUnboxVideoPath = null;
            this.input.unbox_video = null;
        },
        async onVideoFileChange(e) {
            if (
                !e ||
                !e.target ||
                !e.target.files ||
                e.target.files.length === 0
            ) {
                return;
            }
            const file = e.target.files[0];

            this.isShowLoadingOverlay = true;

            try {
                const {
                    presigned_url,
                    file_path
                } = await this.getPresignedUrl(file.name, file.type);

                await this.uploadToS3(file, presigned_url);
                const fullPath = `${this.findingsDirPath}/${
                    this.item.no_faktur
                }/${file_path}`;

                this.uploadedUnboxVideoPath = fullPath;
                this.videoPreviewUrl = URL.createObjectURL(file);
            } catch (error) {
                this.$helper.toastError(this, "Gagal mengupload video unboxing");
                this.clearVideoUnboxing();
            } finally {
                this.isShowLoadingOverlay = false;
            }
        },
        async onFileChange(e) {
            if (
                !e ||
                !e.target ||
                !e.target.files ||
                e.target.files.length === 0
            ) {
                return;
            }
            const newFiles = Array.from(e.target.files);

            if (this.localPhotos.length + newFiles.length > 10) {
                this.$helper.toastError(this, "Maksimal 10 foto diperbolehkan");
                this.tempPhotos = [];
                return;
            }

            this.isShowLoadingOverlay = true;

            try {
                const uploadPromises = newFiles.map(async (file) => {
                    const {
                        presigned_url,
                        file_path
                    } = await this.getPresignedUrl(file.name, file.type);

                    await this.uploadToS3(file, presigned_url);
                    return `${this.findingsDirPath}/${this.item.no_faktur}/${file_path}`;
                });

                const uploadedPaths = await Promise.all(uploadPromises);
                this.uploadedFilePaths.push(...uploadedPaths);

                this.localPhotos = [...this.localPhotos, ...newFiles];
                this.generatePreviews();
            } catch (error) {
                this.$helper.toastError(this, "Gagal mengupload foto");
            } finally {
                this.$nextTick(() => {
                    this.tempPhotos = [];
                });
                this.isShowLoadingOverlay = false;
            }
        },
        generatePreviews() {
            this.previews = [];
            if (!this.localPhotos) return;

            this.localPhotos.forEach(file => {
                this.previews.push({
                    url: URL.createObjectURL(file),
                    type: file.type.startsWith('video/') ? 'video' : 'image'
                });
            });
        },
        removePhoto(index) {
            const newPhotos = [...this.localPhotos];
            newPhotos.splice(index, 1);
            this.localPhotos = newPhotos;

            const newPaths = [...this.uploadedFilePaths];
            newPaths.splice(index, 1);
            this.uploadedFilePaths = newPaths;

            this.previews.splice(index, 1);

            this.generatePreviews();
        },
        async submitFindings() {
            if (!this.input.dry_weight) {
                this.$helper.toastError(this, "Berat Kotor wajib diisi");
                return;
            }
            if (!this.input.weight_reduction) {
                this.$helper.toastError(this, "Berat Potongan wajib diisi");
                return;
            }
            if (!this.input.purity) {
                this.$helper.toastError(this, "Kadar XRF wajib diisi");
                return;
            }
            if (!this.input.category) {
                this.$helper.toastError(this, "Kategori wajib dipilih");
                return;
            }
            if (!this.input.notes) {
                this.$helper.toastError(this, "Catatan wajib diisi");
                return;
            }

            if (this.notesCharCount > 1000) {
                this.$helper.toastError(this, "Catatan maksimal 1000 karakter");
                return;
            }
            if (!this.localPhotos.length) {
                this.$helper.toastError(this, "Foto dan video temuan wajib diupload");
                return;
            }

            this.isSubmitting = true;


            try {
                let isConfirmed = confirm(
                    "Apakah Anda yakin akan membuat temuan ini?"
                );
                if (!isConfirmed) {
                    return;
                }
                const payload = {
                    origin_id: this.item.item.id,
                    origin_type: this.type,
                    dry_weight: parseFloat(this.input.dry_weight).toFixed(2),
                    purity: this.input.purity,
                    weight_reduction: parseFloat(this.input.weight_reduction).toFixed(4),
                    category: this.input.category.name,
                    unbox_video: this.uploadedUnboxVideoPath,
                    notes: this.input.notes,
                    media: this.uploadedFilePaths
                };

                await this.$axios.post(`gold-receipt-variances`, payload);
                this.resetForm();
                this.$helper.toastSuccess(this, "Temuan berhasil dibuat");
                this.$bvModal.hide("m-buat-temuan");
                this.$emit("refresh-items");
            } catch (error) {
                this.$helper.parseError(this, error);
            } finally {
                this.isSubmitting = false;
            }
        },
        showPreviewModal(image) {
            this.selectedPreviewImage = image;
            this.$bvModal.show("m-preview-photo");
        },
        formatNames() {
            return "Tambah Foto...";
        },
        formatTime(date) {
            const hh = String(date.getHours()).padStart(2, "0");
            const mm = String(date.getMinutes()).padStart(2, "0");
            const ss = String(date.getSeconds()).padStart(2, "0");
            return `${hh}:${mm}:${ss}`;
        }
    }
};
</script>
